// IE Polyfill
import objectFitImages from 'object-fit-images';

import Nav from './Nav';
import NavMobile from './NavMobile';
import ArticlesList from './ArticlesList';
import AccordionList from './AccordionList';
import ExpandableContentList from './ExpandableContentList';
import HomeCarousel from './HomeCarousel';
import SvgToInline from './SvgToInline';

$(document).ready(function () {

    /**
     * IE Polyfill for images using object-fit
     */
    objectFitImages();

    let body = document.getElementsByTagName('body')[0];
    /**
     * Nav
     */
    let nav = new Nav();

    /**
     * Nav - Mobile
     */
    let navMobile = new NavMobile();

    /**
     * Body Element, check window width and add 'desktop' class if > 1000. 
     * Also, make sure Navs are reset based on this.
     */
    if (window.innerWidth >= 1000) {
        body.classList.add('desktop');
        navMobile.disable();
        nav.enable();
    } else {
        navMobile.enable();
        nav.disable();
    }

    /**
     * Home - Hero Carousel
     */
    let homeCarousel = new HomeCarousel();

    /**
     * Articles Lists
     */
    let articlesList = new ArticlesList();

    /**
     * Accordion Lists
     */
    let accordionLists = new AccordionList();

    /**
     * Expandable Content Lists
     */
    let expandableContentLists = new ExpandableContentList();

    /**
     * Convert any SVG with class of 'svg' to inline svg
     */
    let svgToInline = new SvgToInline();

    /**
     * Window resize listener
     */
    window.addEventListener('resize', windResizeTimeout);
    let winResizeId;
    function windResizeTimeout() {
        clearTimeout(winResizeId);
        winResizeId = setTimeout(winResize, 500);
    }
    function winResize() {
        /**
         * Check if window width is larger than 1000
         */
        if (window.innerWidth >= 1000 && !body.classList.contains('desktop')) {
            
            /**
             * Close Navs when window resizes past breakpoint
             */
            if (!navMobile.isReset) {
                navMobile.resetMenu();
            }
            /**
             * Add 'desktop' class
             */
            body.classList.add('desktop');
            /**
             * Disable mobile nav
             */
            navMobile.disable();
            /**
             * Enable desktop nav
             */
            nav.enable();
            /**
             * Restart Flickity (for homepage)
             */
            homeCarousel.restartFlickity();
        /**
         * Check if window width is smaller than 1000
         */
        } else if (window.innerWidth <= 1000 && body.classList.contains('desktop')) {
            /**
             * Close Navs when window resizes past breakpoint
             */
            if (!nav.isReset) {
                nav.resetMenu();
            }
            /**
             * Remove 'desktop' class
             */
            body.classList.remove('desktop');
            /**
             * Enable mobile nav
             */
            navMobile.enable();
            /**
             * Disable desktop nav
             */
            nav.disable();
            /**
             * Restart Flickity (for homepage)
             */
            homeCarousel.restartFlickity();
        }
    }

    winResize();
});